import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const TOKEN_KEY = "rp_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const resolveImg = (url) =>
  !url ? "" : url.startsWith("http") ? url : `${BACKEND}${url}`;

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "").join(" ");
  return e?.message || "Something went wrong";
};

export const downloadCsv = (filename, columns, rows) => {
  const esc = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const csv = [
    columns.map((c) => esc(c.label)).join(","),
    ...rows.map((r) => columns.map((c) => esc(r[c.key])).join(",")),
  ].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const api = {
  login: (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }),
  verifyOtp: (pre_token, code) =>
    axios.post(`${API}/auth/verify-otp`, { pre_token, code }),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeaders() }),

  createEnquiry: (data) => axios.post(`${API}/enquiries`, data),
  listEnquiries: () =>
    axios.get(`${API}/enquiries`, { headers: authHeaders() }),
  updateEnquiry: (id, status) =>
    axios.patch(`${API}/enquiries/${id}`, { status }, { headers: authHeaders() }),
  deleteEnquiry: (id) =>
    axios.delete(`${API}/enquiries/${id}`, { headers: authHeaders() }),

  sendTestOtp: () =>
    axios.post(`${API}/auth/send-test-otp`, {}, { headers: authHeaders() }),

  createOrder: (data) =>
    axios.post(`${API}/orders`, data, { headers: authHeaders() }),
  listOrders: () => axios.get(`${API}/orders`, { headers: authHeaders() }),
  updateOrder: (id, updates) =>
    axios.patch(`${API}/orders/${id}`, updates, { headers: authHeaders() }),
  deleteOrder: (id) =>
    axios.delete(`${API}/orders/${id}`, { headers: authHeaders() }),

  listGallery: () => axios.get(`${API}/gallery`),
  uploadGallery: (formData) =>
    axios.post(`${API}/gallery/upload`, formData, { headers: authHeaders() }),
  addGalleryUrl: (image_url, caption) =>
    axios.post(
      `${API}/gallery`,
      { image_url, caption },
      { headers: authHeaders() }
    ),
  deleteGallery: (id) =>
    axios.delete(`${API}/gallery/${id}`, { headers: authHeaders() }),
};
